export const GA4_EVENT = {
  ADD_SHIPMENT_TEMPLATE: 'add_shipment_template',
  PRODUCTS_CHANGE_APPROVAL_STATUS: 'products_change_approval_status',
  PRODUCTS_DETAILS_UPDATE: 'products_details_update',
  PRODUCTS_DELETED: 'products_deleted',
  PRODUCT_LIST_FILTER: 'product_list_filter',
  VIEW_PRODUCT_DEALS: 'view_product_deals',
  PRODUCT_FILTERED_SEARCH: 'product_filtered_search',
  SEARCH_PRODUCT: 'search_product',
  OPEN_PRODUCT_FOR_SALE: 'open_product_for_sale',
  PRODUCT_LINK_CLICK: 'product_link_click',
  DELETE_PRODUCT: 'delete_product',
  DELETE_PRODUCT_SUCCESS: 'delete_product_success',
  DELETE_PRODUCT_DISMISS: 'delete_product_dismiss',
  BUTTON_CLICK: 'button_click',
  PUT_UP_FOR_SALE_SUCCESS: 'put_up_for_sale_success',
  PUT_UP_FOR_SALE_DISMISS: 'put_up_for_sale_dismiss',
  PUT_ON_HOLD_SUCCESS: 'put_on_hold_success',
  PUT_ON_HOLD_DISMISS: 'put_on_hold_dismiss',
  ADD_VARIANT_SUCCESS: 'add_variant_success',
  ADD_VARIANT_DISMISS: 'add_variant_dismiss',
  ADD_ADDITIONAL_VARIANT_SUCCESS: 'add_additional_variant_success',
  ADD_ADDITIONAL_VARIANT_DISMISS: 'add_additional_variant_dismiss',
  REQUEST_UPDATE_REPORT_BUG_SUCCESS: 'request_update_report_bug_success',
  REQUEST_UPDATE_REPORT_BUG_DISMISS: 'request_update_report_bug_dismiss',
  APPLY_SELECTED_ONES: 'apply_selected_ones',
  SAVE_CHANGES: 'save_changes',
  WATCH_TUTORIAL: 'watch_tutorial',
  WATCH_TUTORIAL_DISMISS: 'watch_tutorial_dismiss',
  MENU_CLICK: 'menu_click',
  PAGE_VIEW: 'page_view',
  USE_ALL_BALANCE: 'use_all_balance',
  EARLY_SETTLEMENT_CALCULATE: 'calculate_success',
  EARLY_SETTLEMENT_CALCULATE_FAIL: 'calculate_fail',
  CHECKBOX_CHECKED: 'checkbox_checked',
  CHECKBOX_UNCHECKED: 'checkbox_unchecked',
  EARLY_SETTLEMENT_CALCULATE_DISMISS: 'calculate_dismiss',
  REQUEST_EARLY_PAYMENT: 'request_early_payment',
  REQUEST_EARLY_PAYMENT_SUCCESS: 'request_early_payment_success',
  REQUEST_EARLY_PAYMENT_DISMISS: 'request_early_payment_dismiss',
  REQUEST_EARLY_PAYMENT_FAIL: 'request_early_payment_fail',
  TEMPLATE_DOWNLOAD_FAIL: 'template_download_fail',
  TEMPLATE_UPLOAD_FAIL: 'template_upload_fail',
  TEMPLATE_UPLOAD_SUCCESS: 'template_upload_success',
  REMOVE_PRODUCTS_CAMPAIGN: 'remove_products_campaign',
  REMOVE_PRODUCTS_SUCCESS: 'remove_products_success',
  REMOVE_PRODUCTS_DISMISS: 'remove_products_dismiss',
  REMOVE_PRODUCTS_FAIL: 'remove_products_fail',
  ADD_PRODUCTS_CAMPAIGN: 'add_products_campaign',
  ADD_PRODUCTS_SUCCESS: 'add_products_success',
  ADD_PRODUCTS_FAIL: 'add_products_fail',
  ADD_PRODUCTS_DISMISS: 'add_products_dismiss',
  FILTER_SHOW_RESULT: 'filter_show_result',
  SORT_APPLY: 'sort_apply',
  JOIN_CAMPAIGN: 'join_campaign',
  JOIN_CAMPAIGN_SUCCESS: 'join_campaign_success',
  JOIN_CAMPAIGN_FAIL: 'join_campaign_fail',
  JOIN_CAMPAIGN_DISMISS: 'join_campaign_dismiss',
  JOIN_CAMPAIGN_CLOSE_CLICK: 'join_campaign_close_click',
  JOIN_CAMPAIGN_CANCEL_CLICK: 'join_campaign_cancel_click',
  SELECT_FILE: 'select_file',
  SELECT_PRODUCT: 'select_product',
  GO_TO_PRODUCT_DETAIL_CLICK: 'go_to_product_detail_click',
  JOIN_CAMPAIGN_CLICK: 'join_campaign_click',
  JOIN_CAMPAIGN_SUCCESS_COMISSION: 'join_campaign_success',
  JOIN_CAMPAIGN_DISMISS_COMISSION: 'join_campaign_dismiss',
  TAB_CLICK: 'tab_click',
  VIEW_CAMPAIGN_DETAIL_CLICK_COMISSION: 'view_campaign_detail_click',
  SORT_APPLY_COMISSION: 'sort_apply',
  FILTER_SHOW_RESULTS_COMISSION: 'filter_show_results',
  JOIN_CAMPAIGN_CANCEL_COMISSION: 'join_campaign_cancel',
  JOIN_CAMPAIGN_CLOSE_COMISSION: 'join_campaign_close',
  JOIN_CAMPAIGN_FAIL_COMISSION: 'join_campaign_fail',
  SELECT_FILE: 'select_file',
  SELECT_PRODUCT: 'select_product',
  GO_TO_PRODUCT_DETAIL_CLICK: 'go_to_product_detail_click',
  BANNER_CLICK: 'banner_click',
};
